import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const UserProP = () => {
  const { id } = useParams();

  const [all, setAll] = useState(""); // => [[], function that changes state]
  let newAll = [...all];

  const [user, setUser] = useState("");
  let h = user;
  const [img, setImg] = useState("");

  useEffect(() => {
    axios
      .get("https://insta.nextacademy.com/api/v1/images?userId=" + id)
      .then((res) => {
        setAll(res.data);
        console.log("came here to images of an id");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get("https://aqueous-plains-06808.herokuapp.com/api/v1/users/" + id)
      .then((res) => {
        console.log(res);
        console.log("came here to users/id");
        setUser(res.data[0].username);
        setImg(res.data[0].profileImage);
        setAll(res.data[1]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        border: "1px solid grey",
        borderRadius: "10px",
      }}
    >
      <h3 className="my-3">
        <b>{h}</b>'s Profile
      </h3>
      <img
        style={{
          width: "400px",
          height: "300px",
          border: "5px solid brown",
          borderRadius: "10%",
        }}
        src={img}
        alt="img"
      />
      <div
        className="my-5 d-flex"
        style={{
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        {newAll.map((v) => (
          <div
            className="m-2"
            style={{
              border: "2px solid darkgray",
            }}
          >
            <img
              style={{ width: "180px", height: "180px" }}
              src={v}
              alt="img"
            />
          </div>
        ))}{" "}
      </div>
    </div>
  );
};

export default UserProP;
